export var ToolKind;
(function (ToolKind) {
    ToolKind["Note"] = "note";
    ToolKind["Layer"] = "layer";
    ToolKind["Exit"] = "exit";
    ToolKind["Inliner"] = "inliner";
})(ToolKind || (ToolKind = {}));
// @deprecated ?
export var DefaultStep;
(function (DefaultStep) {
    DefaultStep["Success"] = "success";
    DefaultStep["Failure"] = "failure";
    DefaultStep["Main"] = "main";
})(DefaultStep || (DefaultStep = {}));
export var LoginStep;
(function (LoginStep) {
    LoginStep["LoginSignin"] = "login-signin";
    LoginStep["LoginRegister"] = "login-register";
    LoginStep["LoginSuccess"] = "login-success";
})(LoginStep || (LoginStep = {}));
//# sourceMappingURL=tool.types.js.map